export default __webpack_public_path__ + "static/media/coindesk_logo.89135a29.svg";